(function () {
  'use strict';

  var STORAGE_KEY = 'ct_attribution_v81';
  var AI_HOSTS = {
    'chatgpt.com': 'chatgpt',
    'chat.openai.com': 'chatgpt',
    'openai.com': 'openai',
    'perplexity.ai': 'perplexity',
    'www.perplexity.ai': 'perplexity',
    'copilot.microsoft.com': 'copilot',
    'gemini.google.com': 'gemini',
    'claude.ai': 'claude'
  };

  function clean(value, limit) {
    return String(value || '').trim().slice(0, limit || 120);
  }

  function hostFrom(url) {
    if (!url) return '';
    try { return new URL(url).hostname.toLowerCase().replace(/^www\./, ''); }
    catch (error) { return ''; }
  }

  function readStored() {
    try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (error) { return {}; }
  }

  function writeStored(value) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); }
    catch (error) { /* Attribution must never interrupt shopping. */ }
  }

  var params = new URLSearchParams(window.location.search);
  var referrerHost = hostFrom(document.referrer);
  var source = clean(params.get('utm_source') || referrerHost || 'direct', 80).toLowerCase();
  var aiSource = AI_HOSTS[referrerHost] || AI_HOSTS[source] || (/chatgpt|openai/.test(source) ? 'chatgpt' : '');
  var now = new Date().toISOString();
  var existing = readStored();
  var current = {
    source: source,
    medium: clean(params.get('utm_medium') || (referrerHost ? 'referral' : 'direct'), 80),
    campaign: clean(params.get('utm_campaign'), 120),
    content: clean(params.get('utm_content'), 120),
    landing: clean(window.location.pathname, 180),
    referrer_host: clean(referrerHost, 120),
    ai_source: clean(aiSource, 40),
    touched_at: now
  };

  var record = {
    first: existing.first || current,
    last: current
  };
  writeStored(record);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'ct_attribution_ready',
    ct_source: record.first.source,
    ct_medium: record.first.medium,
    ct_campaign: record.first.campaign,
    ct_ai_source: record.first.ai_source,
    ct_landing: record.first.landing
  });

  var syncing = false;
  var synced = false;

  function syncCartAttribution() {
    if (syncing || synced) return;
    syncing = true;

    var attributes = {
      'CT first source': clean(record.first.source, 80),
      'CT first medium': clean(record.first.medium, 80),
      'CT first campaign': clean(record.first.campaign, 120),
      'CT first landing': clean(record.first.landing, 180),
      'CT first AI source': clean(record.first.ai_source, 40),
      'CT first referrer': clean(record.first.referrer_host, 120),
      'CT first touched': clean(record.first.touched_at, 40),
      'CT last source': clean(record.last.source, 80),
      'CT last AI source': clean(record.last.ai_source, 40)
    };

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes: attributes}),
      keepalive: true
    }).then(function (response) {
      if (response.ok) synced = true;
    }).catch(function () {
      /* Never block add-to-cart or checkout if attribution cannot be saved. */
    }).finally(function () {
      syncing = false;
    });
  }

  document.addEventListener('ct:add_to_cart', syncCartAttribution);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches('form[action*="/cart/add"], form[action*="/cart"]')) syncCartAttribution();
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[name="checkout"], a[href*="/checkout"], button[type="submit"][name="add"]')) {
      syncCartAttribution();
    }
  }, true);
}());
